var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollaborateurs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#EE7203;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.8,82.3c0.7,0,1.2-0.5,1.2-1.2c0-15.2-12.4-27.6-27.6-27.6S34.8,65.9,34.8,81.1c0,0.7,0.5,1.2,1.2,1.2H88.8 z M37.3,79.1c1-13,12-23.2,25.1-23.2c13.1,0,24.1,10.2,25.1,23.2l0.1,0.8H37.3L37.3,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,17.7c-8.8,0-15.9,7.1-15.9,15.9S53.2,49.5,62,49.5s15.9-7.1,15.9-15.9S70.7,17.7,62,17.7z M62,47.1 c-7.4,0-13.5-6.1-13.5-13.5S54.5,20.1,62,20.1c7.4,0,13.5,6.1,13.5,13.5S69.4,47.1,62,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,65.2c0.3,0.2,0.6,0.2,0.9,0.1c0.3-0.1,0.6-0.3,0.7-0.6c0.2-0.3,0.2-0.6,0.1-0.9 c-0.1-0.3-0.3-0.6-0.6-0.7c-3.2-1.9-6.8-2.9-10.5-2.9C13.3,60.3,4,69.6,4,81.1c0,0.7,0.5,1.2,1.2,1.2h24.4c0.7,0,1.2-0.5,1.2-1.2 s-0.5-1.2-1.2-1.2H6.4l0.1-0.8c1-9.4,8.9-16.4,18.3-16.4C28.1,62.7,31.3,63.5,34.1,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.5,31.5c-6.7,0-12.1,5.4-12.1,12.1s5.4,12.1,12.1,12.1s12.1-5.4,12.1-12.1S31.1,31.5,24.5,31.5z M24.5,53.3 c-5.4,0-9.7-4.4-9.7-9.7s4.4-9.7,9.7-9.7s9.7,4.4,9.7,9.7S29.8,53.3,24.5,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.4,82.3h24.4c0.7,0,1.2-0.5,1.2-1.2c0-11.5-9.3-20.8-20.8-20.8c-3.7,0-7.4,1-10.5,2.9 c-0.3,0.2-0.5,0.4-0.6,0.7c-0.1,0.3,0,0.6,0.1,0.9c0.2,0.3,0.4,0.5,0.7,0.6c0.3,0.1,0.6,0,0.9-0.1c2.8-1.7,6.1-2.5,9.3-2.5 c9.4,0,17.3,7.1,18.3,16.4l0.1,0.8H95.4c-0.7,0-1.2,0.5-1.2,1.2S94.8,82.3,95.4,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,31.5c-6.7,0-12.1,5.4-12.1,12.1c0,6.7,5.4,12.1,12.1,12.1s12.1-5.4,12.1-12.1S107.2,31.5,100.5,31.5z  M100.5,53.3c-5.4,0-9.7-4.4-9.7-9.7c0-5.4,4.4-9.7,9.7-9.7c5.4,0,9.7,4.4,9.7,9.7S105.9,53.3,100.5,53.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborateurs);
export default __webpack_public_path__ + "static/media/collaborateurs.810bd1d95c10720a029954c6087b0ff3.svg";
export { ForwardRef as ReactComponent };